<template>
  <v-container
    fluid
    fill-height>
    <v-layout
      align-center
      justify-center>
      <v-flex
        xs12
        sm8
        lg6>
        <Card>
          <template slot="header">Reset Password</template>
          <v-container>
            Enter your email address and we will send instructions for resetting your password.
            <v-text-field
              v-model="form.email"
              label="Email"
              prepend-icon="fa-envelope"
            />
            <v-layout column>
              <v-btn @click="submit">
                Submit
              </v-btn>
              <v-flex>
                <v-layout justify-center>
                  <router-link
                    :to="{ path: '/signin/login'}"
                    class="pa-3">Login</router-link>
                  <router-link
                    :to="{ path: '/signin/signup' }"
                    class="pa-3">Signup</router-link>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </Card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// import vuex mapping
import { mapActions } from 'vuex'

// our new component
export default {
  data () {
    return {
      form: {
        email: null
      }
    }
  },
  methods: {
    ...mapActions({
      passwordResetRequest: 'person/passwordResetRequest'
    }),
    submit () {
      this.passwordResetRequest(this.form)
    }
  }
}
</script>
